/** Clases compartidas por los campos del formulario. */
export const campo =
  'w-full rounded-field border border-line bg-surface-2 px-3 py-[11px] text-base text-ink outline-none placeholder:text-ink-faint transition-[border-color,box-shadow] duration-150 ease-soft focus:border-accent focus:shadow-[0_0_0_3px_var(--accent-soft)]'

export const etiqueta =
  'mb-1.5 block text-[11.5px] font-semibold uppercase tracking-[0.075em] text-ink-soft'

export const opcional = 'normal-case tracking-normal font-normal text-ink-faint'
